import Button from 'components/Button';
import DownloadIcon from 'components/icons/Download';
import { FC, useState } from 'react';
import styled from 'styled-components';
import DocumentationFile from 'types/DocumentationFile';
import downloadFile from 'utils/downloadFile';

const Container = styled.div`
  color: black;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.3rem;
  border: 1px solid var(--gray-200);
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
`;

type DocumentProps = {
  document: DocumentationFile;
  downloadUrl: string;
};
const DocumentComponent: FC<DocumentProps> = ({ document, downloadUrl }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const handleDownload = () => {
    setLoading(true);
    downloadFile(
      `${downloadUrl}/${document.id}`,
      document.filename || 'fichier',
    )
      .catch(() => {
        setError(true);
        setTimeout(() => setError(false), 1000);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Container>
      {document.title}
      <Button
        color={error ? 'error' : 'primary'}
        variant={error ? 'soft-outlined' : 'filled'}
        type="button"
        icon={<DownloadIcon />}
        onClick={handleDownload}
        loading={loading}
      >
        {error ? 'Erreur' : 'Télécharger'}
      </Button>
    </Container>
  );
};

export default DocumentComponent;
